class AssignedEmployeeEntity {
    constructor(object={}){
        this.name = object?.user?.full_name || '';
        this.title = object?.title || '';
        this.username = object?.username || '';
        this.id = object?.id || null;
   }
  }
  
  export default AssignedEmployeeEntity;